import {IService} from "@/model/Service/Service"
import {IInsurance} from "@/model/Insurance/Insurance"
import {IServiceFamily} from "@/model/ServiceFamily/ServiceFamily"
import {IInsuranceFamily} from "@/model/InsuranceFamily/InsuranceFamily"
import {IFee} from "@/model/Fee/Fee"
import {IAccomodation} from "@/model/Accomodation"
import {ITraveller} from "@/model/Traveller"
import {IServiceFamilyConfig} from "@/model/ServiceFamilyConfig"
import Lihe, {ILihe} from "@/model/Lihe"
import {IDiscount} from "@/model/Discount"
import {IAPIResponses} from "@/classes/APIResponses"


export interface IBookingData {
    responses: IAPIResponses
    travellersArr: ITraveller[]
    travellersMap: Map<string, ITraveller>
    feesArr: IFee[]
    feesMap: Map<string, IFee>
    accomodationsArr: IAccomodation[]
    accomodationsMap: Map<string, IAccomodation>

    servicesArr: IService[]
    servicesMap: Map<string, IService>
    selectedServicesMap: Map<string, IService>
    serviceFamiliesArr: IServiceFamily[]
    serviceFamiliesMap: Map<string, IServiceFamily>
    selectedServiceFamiliesMap: Map<string, IServiceFamily>

    insurancesArr: IInsurance[]
    insurancesMap: Map<string, IInsurance>
    selectedInsurancesMap: Map<string, IInsurance>
    insuranceFamiliesArr: IInsuranceFamily[]
    insuranceFamiliesMap: Map<string, IInsuranceFamily>
    selectedInsuranceFamiliesMap: Map<string, IInsuranceFamily>

    funnelConfigArr: IServiceFamilyConfig[]
    funnelConfigMap: Map<string, IServiceFamilyConfig>
    totalPrice: number
    discounts: IDiscount[] // TODO ?
    lihe: ILihe
    commercialDiscount?: number
    packagePrice?: { initialPackagePrice: number; toDisplayPackagePrice: number; actualPackagePrice: number; }
}

export default class BookingData implements IBookingData {
    public responses: IAPIResponses
    public travellersArr: ITraveller[] = []
    public travellersMap: Map<string, ITraveller> = new Map()
    public feesArr: IFee[] = []
    public feesMap: Map<string, IFee> = new Map()
    public accomodationsArr: IAccomodation[] = []
    public accomodationsMap: Map<string, IAccomodation> = new Map()

    public servicesArr: IService[] = []
    public servicesMap: Map<string, IService> = new Map()
    public selectedServicesMap: Map<string, IService> = new Map()
    public serviceFamiliesArr: IServiceFamily[] = []
    public serviceFamiliesMap: Map<string, IServiceFamily> = new Map()
    public selectedServiceFamiliesMap: Map<string, IServiceFamily> = new Map()

    public insurancesArr: IInsurance[] = []
    public insurancesMap: Map<string, IInsurance> = new Map()
    public selectedInsurancesMap: Map<string, IInsurance> = new Map()
    public insuranceFamiliesArr: IInsuranceFamily[] = []
    public insuranceFamiliesMap: Map<string, IInsuranceFamily> = new Map()
    public selectedInsuranceFamiliesMap: Map<string, IInsuranceFamily> = new Map()

    public funnelConfigArr: IServiceFamilyConfig[] = []
    public funnelConfigMap: Map<string, IServiceFamilyConfig> = new Map()
    public totalPrice = 0
    public discounts: IDiscount[] = [] // TODO ?
    public lihe: ILihe = new Lihe()
    public commercialDiscount?: number
    public packagePrice?: { initialPackagePrice: number; toDisplayPackagePrice: number; actualPackagePrice: number; }


    constructor(responses: IAPIResponses) {
        this.responses = responses
    }
}